/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
    // 倒计时
    function getRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
  
    let endTimeG;
  
    function cutDownTime() {
      let nowTime = new Date();
      let endTime = new Date(endTimeG);
  
      let leftTime = endTime.getTime() - nowTime.getTime();
      if (leftTime < 0) {
        setupNewCountdown();
        leftTime = 0;
      }
      let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
        leftM = Math.floor((leftTime / (1000 * 60)) % 60),
        leftS = Math.floor((leftTime / 1000) % 60);
      leftH = leftH >= 10 ? leftH : "0" + leftH;
      leftM = leftM >= 10 ? leftM : "0" + leftM;
      leftS = leftS >= 10 ? leftS : "0" + leftS;
  
      return {
        hour: leftH,
        minute: leftM,
        second: leftS,
      };
    }
    function setupNewCountdown() {
      const randomHour = getRandomNum(1, 9);
      const currentTime = new Date();
      endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;
  
    function getCutDownTime() {
      setupNewCountdown();
      if (intervalId) clearInterval(intervalId);
      intervalId = setInterval(function () {
        let cutDownTimeText = cutDownTime();
        $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
        $(".sp_top_cut_down .sp_left_view .sp_minute").html(
          cutDownTimeText.minute
        );
        $(".sp_top_cut_down .sp_left_view .sp_second").html(
          cutDownTimeText.second
        );
      }, 1000);
    }
  
    getCutDownTime();
  
    let spImgList = [
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p1.png",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p2.png",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p3.jpg",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p4.png",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p5.png",
  
  
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-b1.png",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-b2.png",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-b3.png",
    ];
    let spImgList2 = [
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p3.jpg",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p2.png",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p5.png",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p1.png",
      "https://cdn.shopify.com/s/files/1/0818/6052/6378/files/20250110-p4.png",
    ];
  
    new Swiper(".sp-swiper1", {
      autoplay: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 5000,
      },
      pagination: {
        el: ".sp-pagination1",
        clickable: true,
      },
      spaceBetween: 0,
      loop: true,
    });
    function mainRender() {
      $(function () {
        $("#root").css("zoom", "normal");
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
  
        window.addEventListener(
          "resize",
          (function () {
            var timer;
            return function () {
              if (timer) clearTimeout(timer);
              timer = setTimeout(function () {
                $("#root").css("zoom", "normal");
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              }, 100);
            };
          })()
        );
      });
  
      function lazyLoadImages() {
        // 懒加载
        const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
        const config = {
          rootMargin: "0px 0px 1300px 0px",
          threshold: 0,
        };
  
        const lazyLoadObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // 当图片进入视口时
              const image = entry.target;
              const dataSrc = image.getAttribute("data-src");
              image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
              lazyLoadObserver.unobserve(image); // 停止观察该图片
            }
          });
        },
        config);
  
        images.forEach(function (image) {
          lazyLoadObserver.observe(image); // 开始观察每个图片
        });
      }
  
      function preloadImages(imageArray) {
        // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) {
          // 处理二维数组
          imageArray.forEach((subArray) => {
            subArray.forEach((url) => {
              const img = new Image();
              img.src = url;
            });
          });
        } else {
          // 处理一维数组
          imageArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        }
      }
  
      lazyLoadImages();
  
      preloadImages(spImgList);
  
      // 找到所有跳转套餐的锚点链接
      var links = document.querySelectorAll('a[href^="#shopping"]');
      links.forEach(function (link) {
        link.addEventListener("click", function (event) {
          event.preventDefault(); // 阻止默认的跳转行为
          // var targetElement = document.getElementById('shopping');
          // if (targetElement) {
          //     targetElement.scrollIntoView({ behavior: 'smooth' });
          // } // 方式一
          const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
          const offsetTop = targetElement.offsetTop;
          window.scroll({
            top:
              offsetTop * $("div#root").css("zoom") -
              255 * $("div#root").css("zoom"),
            behavior: "smooth", // 使用 smooth 实现平滑滚动
          }); // 方式二
        });
      });
  
      // IOS字体多了间距的处理 给节点添加 sp_system 类名
      // 判断当前用户是安卓端还是iOS端
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var isAndroid = /android/i.test(userAgent);
      var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断
  
      if (isAndroid) {
        console.log("Android");
      } else if (isIOS) {
        console.log("iOS");
      } else if (isPC) {
        console.log("PC");
      } else {
        $(".sp_system").css("letter-spacing", "-4px");
      }
    }
  
    mainRender();
  
    let prods = window.product
      // 数字框
      function getCur(){
        let color = $('.sp-color1 div.active').attr('data-val')
        let size = $('.sp-color2 div.active').attr('data-val')
        let size3 = $('.sp-color3 div.active').attr('data-val')
        return prods.filter(item=> item.option1 == color && item.option2 == size && item.option3 == size3)[0]
      }
      function changePrice(){
        let num = $('#calcNumber').val()
        let price = (getCur().price * num / 100).toFixed(2)
        let compare = (getCur().compare_at_price * num / 100).toFixed(2)
        // price = (price + '').replace('.', ',')
        // compare = (compare + '').replace('.', ',')
        $('#sp_price1').html(price)
        $('#sp_price2').html(compare)
        let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
        $(".product-part .sp-row span").html(off_font);
  
      }
  
    $(".sp-reduce").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) - 1;
      if (num > 0) {
        input.value = num;
        changePrice()
      }
    });
    $(".sp-add").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) + 1;
      input.value = num;
      changePrice()
    });
    $('.sp-btn-style').click(function(){
        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
      })
  
    $(function () {
      $(".sp-option").click(function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        // style选项
        let colorOptions = $(".sp-color1 .sp-option.active").index();
        let color2Options = $(".sp-color2 .sp-option.active").index();
        let color3 = $(".sp-color3 .sp-option.active").index();
        if(color2Options==0){
          $(".tip1").html('')
          $(".tip2").html('')
        }else if(color2Options==1){
          $(".tip1").html('x2')
          $(".tip2").html('x1')
        }else{
          $(".tip1").html('x3')
          $(".tip2").html('x2')
        }
        if(colorOptions==1){
          $(".tip1").css("color","#000")
          $(".tip2").css("color","#000")
        }else{
          $(".tip1").css("color","#fff")
          $(".tip2").css("color","#fff")
        }
  
        if (color3 == 1) {
          $(".tip1").css({
            'left': '55px'
          })
          $(".tip2").css({
            'left': '55px'
          })
          $(".sp-img1").css({
            'width': '400px',
            'height': '500px'
          })
          $(".sp-img2").css({
            'width': '400px',
            'height': '500px'
          })
          $(".sp-img3").show()
        } else {
          $(".tip1").css({
            'left': '55px'
          })
          $(".tip2").css({
            'left': '55px'
          })
          $(".sp-img1").css({
            'width': '493px',
            'height': '540px'
          })
          $(".sp-img2").css({
            'width': '493px',
            'height': '540px'
          })
          $(".sp-img3").hide()
        }
  
        $(".product-part .sp-img1")[0].src = spImgList2[colorOptions];
        $(".product-part .sp-img2")[0].src = spImgList2[colorOptions];
        changePrice()
      });
  
      // style选项
      // // 处理加入购物车事件
      // function handleAddToCart(num) {
      //   if (num > 0) {
      //     $("#cardNum").html(num).show();
      //     $(".sp-top-btn").addClass("sp-high");
      //     $(".sp-top-btn span").html("Check out");
      //     $(".sp-header-top .sp-cart").addClass("on");
      //   } else {
      //     $("#cardNum").html(0).hide();
  
      //     $(".sp-top-btn").removeClass("sp-high");
      //     $(".sp-top-btn span").html("Buy now");
      //     $(".sp-header-top .sp-cart").removeClass("on");
      //   }
      // }
      // handleAddToCart(0);
  
      // 购物车加购动效
      $(".cart-btn").click(function () {
        $(this).children("img").addClass("on");
        $(".sp-header-top .sp-cart .num").show();
        setTimeout(function () {
          $(".cart-btn").children("img").removeClass("on");
        }, 500);
        $(".sp-header-top .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-header-top .sp-cart").removeClass("on");
        }, 500);
      });
      let initNum = 0;
      $(".product-part .cart-btn").click(function () {
        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $("#cardNum").html(result.item_count);
            });
          },
          dataType: "json",
        });
        var img = $(".product-part .sp-img1");
        // var img = $(".product-part .swiper-slide-active .sp-img");
  
        var flyer = img[0].cloneNode(true);
        flyer.classList.add("sp_clone");
  
        $(".product-part").append(flyer);
        $(".sp_clone").css({
          width: img[0].width,
          height: img[0].height,
          position: "fixed",
          top: img[0].offsetTop,
          left: img.offset().left,
          "z-index": "99",
        });
  
        let finish = $(".sp-cart");
        $(".sp_clone").animate(
          {
            top:
              finish[0].offsetTop +
              finish.height() / 2 +
              $(".time-part").height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
  
        //
        var img2 = $(".product-part .sp-img2");
        // var img = $(".product-part .swiper-slide-active .sp-img");
  
        var flyer2 = img2[0].cloneNode(true);
        flyer2.classList.add("sp_clone");
  
        $(".product-part").append(flyer2);
        $(".sp_clone").css({
          width: img[0].width,
          height: img[0].height,
          position: "fixed",
          top: img[0].offsetTop,
          left: img2.offset().left + img2.width() / 2,
          "z-index": "99",
        });
  
        $(".sp_clone").animate(
          {
            top:
              finish[0].offsetTop +
              finish.height() / 2 +
              $(".time-part").height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });
  